export { default as LanguageSwitcher } from "./LanguageSwitcher";
